import {
    APPLICATION_LIST_REQUEST,
    APPLICATION_LIST_SUCCESS,
    APPLICATION_LIST_FAIL,
    APPLICATION_LIST_RESET,
    INVOICE_APPLICATION_LIST_REQUEST,
    INVOICE_APPLICATION_LIST_SUCCESS,
    INVOICE_APPLICATION_LIST_FAIL,
} from '../constants/applicationConstants'
import api from '../core/api'

export const listApplications = (contactId, dealId) => async (dispatch, getState) => {
    try {
        dispatch({ type: APPLICATION_LIST_REQUEST })

        const { data } = await api.get(
            "/applications/getApplication/" + contactId + "/" + dealId,
        )

        var dt = data.Result;
        if (typeof (dt) == 'string') {
            dispatch({
                type: APPLICATION_LIST_FAIL,
                payload: dt
            })
        } else {
            dispatch({
                type: APPLICATION_LIST_SUCCESS,
                payload: data.Result
            })
        }
    }
    catch (error) {
        dispatch({
            type: APPLICATION_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}

export const listInvoiceApplication = (applicationId) => async (dispatch, getState) => {
    try {
        dispatch({ type: INVOICE_APPLICATION_LIST_REQUEST })

        const { data } = await api.get(
            "/accounts/application/" + applicationId,
        )
            //console.log(data.Result);
        var dt = data.Result;
        if (typeof (dt) == 'string') {
            dispatch({
                type: INVOICE_APPLICATION_LIST_FAIL,
                payload: dt
            })
        } else {
            dispatch({
                type: INVOICE_APPLICATION_LIST_SUCCESS,
                payload: data.Result
            })
        }
    }
    catch (error) {
        dispatch({
            type: INVOICE_APPLICATION_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }
}